import { FormSection, Timeline } from '@ksyos/design-system';
import { useProcessStartWizardWithCards } from '@frontend/utils/hooks/useProcessStartWizardWithCards';

export function GgzbTherV1FollowingSteps() {
    const hasProcessStartWizardWithCards = useProcessStartWizardWithCards();

    if (!hasProcessStartWizardWithCards) {
        return null;
    }

    return (
        <FormSection title="Vervolgstappen begeleiding Therapieland">
            <Timeline>
                <Timeline.Item>
                    De patiënt ontvangt een e-mail van Therapieland met een link om een account aan te maken
                </Timeline.Item>
                <Timeline.Item>De patiënt gaat aan de slag in het verstuurde programma</Timeline.Item>
                <Timeline.Item>Je monitort de voortgang in het Ksyos platform</Timeline.Item>
                <Timeline.Item>Je archiveert het programma wanneer de patiënt klaar is</Timeline.Item>
            </Timeline>
        </FormSection>
    );
}
